import * as React from "react";

function IconHomebotApp(props) {
  return (
    <svg width={64} height={64} fill="none" {...props}>
  <rect
    width={64}
    height={64}
    rx={11.378}
    fill="color(display-p3 .1176 .1098 .1373)"
  />
  <rect
    x={0.5}
    y={0.5}
    width={63}
    height={63}
    rx={10.878}
    stroke="#000"
    strokeOpacity={0.64}
  />
  <circle
    cx={32}
    cy={32}
    r={21.678}
    fill="color(display-p3 .1176 .1098 .1373)"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M32 51.528c10.785 0 19.528-8.743 19.528-19.528 0-10.785-8.743-19.528-19.528-19.528-10.785 0-19.528 8.743-19.528 19.528 0 10.785 8.743 19.528 19.528 19.528zm0 3.583c12.764 0 23.11-10.347 23.11-23.111C55.11 19.236 44.765 8.889 32 8.889S8.889 19.236 8.889 32c0 12.764 10.347 23.111 23.11 23.111z"
    fill="url(#prefix__paint0_linear_2935_1261)"
  />
  <g clipPath="url(#prefix__clip0_2935_1261)">
    <circle
      cx={32.114}
      cy={23.711}
      r={6.36}
      fill="color(display-p3 .4549 .1137 .2902)"
    />
    <circle
      cx={32.114}
      cy={23.711}
      r={4.568}
      fill="color(display-p3 .8588 .1176 .4706)"
    />
  </g>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M33.68 33.427a2.659 2.659 0 105.319 0 2.66 2.66 0 10-5.32 0zm-8.627 0a2.659 2.659 0 105.319 0 2.66 2.66 0 10-5.32 0zm2.994 9.925h-2.91a1.728 1.728 0 01-1.726-1.73v-3.04h-1.027a.93.93 0 01-.929-.931v-3.765a.93.93 0 01.93-.931h1.026v-3.691c0-.955.773-1.727 1.726-1.727h6.37V26.48a2.732 2.732 0 01.542-5.41 2.731 2.731 0 01.435 5.43v1.036h6.39c.953 0 1.726.774 1.726 1.727v3.691h1.014a.93.93 0 01.93.93v3.766c0 .514-.417.93-.93.93H40.6v3.041c0 .956-.775 1.73-1.727 1.73H28.049zm-1.297-4.804c-.583 0-1.056.483-1.056 1.06v.161c0 .586.475 1.06 1.056 1.06h10.795c.583 0 1.056-.483 1.056-1.06v-.16a1.06 1.06 0 00-1.056-1.061H26.75z"
    fill="color(display-p3 .9804 .9608 .9725)"
  />
  <defs>
    <linearGradient
      id="prefix__paint0_linear_2935_1261"
      x1={42.565}
      y1={12.411}
      x2={19.674}
      y2={51.81}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0.44} stopColor="color(display-p3 .9608 .1176 .5176)" />
      <stop offset={0.83} stopColor="color(display-p3 .8076 .0787 .7468)" />
    </linearGradient>
    <clipPath id="prefix__clip0_2935_1261">
      <path
        fill="#fff"
        transform="translate(25.754 17.488)"
        d="M0 0h12.72v12.72H0z"
      />
    </clipPath>
  </defs>
</svg>






  );
}

const MemoIconHomebotApp = React.memo(IconHomebotApp);
export default MemoIconHomebotApp;
